export default {
    // host: 'http://git.breakinghits.com',
    host: 'https://api.breakinghits.com',
    // host: 'http://localhost:3031'
};